import React from 'react';
import OTPModal from '../PasswordAlert';
import { ModalContent, ButtonContainer, CancelButton } from './styles';
import TextView from '../TextView';
import Button from '../Button';

export const WheelLimitPopup = ({ open, handleClose, type }) => {
    return (
        <OTPModal
          open={open}
          handleClose={handleClose}
          title={type === "clone" ? "Upgrade to Clone More Wheels!" : "Upgrade to Create More Wheels!"}
          width={"600px"}
        >
          <ModalContent>
            <TextView variant="subtitle">
              You've reached your{" "}
              <span style={{ fontWeight: 700 }}>
                {type === "clone" ? "limit of 5 Clones" : "limit of 5 Wheels"}
              </span>. Upgrade your plan to unlock unlimited {type === "clone" ? "Clones" : "Wheel creation"} and enjoy all of the additional features!
            </TextView>
            <ButtonContainer>
              <CancelButton onClick={handleClose}>
                Cancel
              </CancelButton>
              <Button>Update Today!</Button>
            </ButtonContainer>
          </ModalContent>
        </OTPModal>
    )
}